import { Injectable } from '@angular/core';
import { MenuItem } from '@app/interfaces';
import { MenuService } from '@app/services/menu/menu.service';

const ApplicantProfileMenu: MenuItem[] = [
    {
        key: 'applicant-tracker.application',
        link: ['./'],
        routerLinkExact: true,
    },
    {
        key: 'applicant-tracker.questions',
        link: ['./questions'],
    },
    {
        key: 'applicant-tracker.documentsAndLinks',
        link: ['./documents-and-links'],
    },
    {
        key: 'applicant-tracker.comments',
        link: ['./comments'],
    },
    {
        key: 'applicant-tracker.interviews',
        link: ['./interviews'],
    },
    {
        key: 'applicant-tracker.emails',
        link: ['./emails'],
    },
];

@Injectable()
export class ApplicantProfileMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = ApplicantProfileMenu;
    }
}
